import css from './css.module.scss';

// Two cookies (one bitten) with chocolate chips and a few crumbs, drawn inline.
const CookieArt = () => (
  <svg className={css.art} viewBox="0 0 140 96" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="cookieDough" cx="38%" cy="32%" r="75%">
        <stop offset="0%" stopColor="#f6dcb0" />
        <stop offset="70%" stopColor="#e9bf83" />
        <stop offset="100%" stopColor="#d9a463" />
      </radialGradient>
      <radialGradient id="cookieDoughBack" cx="40%" cy="35%" r="75%">
        <stop offset="0%" stopColor="#f1d3a2" />
        <stop offset="100%" stopColor="#cf9757" />
      </radialGradient>
      <filter id="cookieShadow" x="-20%" y="-20%" width="140%" height="150%">
        <feDropShadow dx="0" dy="6" stdDeviation="5" floodColor="#6168f2" floodOpacity="0.18" />
      </filter>
      {/* bite taken out of the front cookie */}
      <mask id="cookieBite">
        <rect width="140" height="96" fill="#fff" />
        <circle cx="112" cy="20" r="11" fill="#000" />
        <circle cx="122" cy="33" r="8" fill="#000" />
        <circle cx="103" cy="12" r="6" fill="#000" />
      </mask>
    </defs>

    {/* back cookie */}
    <g className={css.cookieBack} filter="url(#cookieShadow)">
      <circle cx="44" cy="54" r="30" fill="url(#cookieDoughBack)" />
      <circle cx="44" cy="54" r="30" fill="none" stroke="#c48a4b" strokeWidth="1.5" opacity="0.5" />
      <ellipse cx="34" cy="44" rx="4.5" ry="3.6" fill="#5b3a26" />
      <ellipse cx="54" cy="48" rx="3.6" ry="3" fill="#5b3a26" />
      <ellipse cx="40" cy="64" rx="4" ry="3.2" fill="#5b3a26" />
      <ellipse cx="57" cy="66" rx="3" ry="2.6" fill="#5b3a26" />
      <ellipse cx="27" cy="58" rx="2.6" ry="2.2" fill="#5b3a26" />
    </g>

    {/* front cookie, bitten */}
    <g className={css.cookieFront} filter="url(#cookieShadow)">
      <g mask="url(#cookieBite)">
        <circle cx="90" cy="42" r="34" fill="url(#cookieDough)" />
        <circle cx="90" cy="42" r="34" fill="none" stroke="#c48a4b" strokeWidth="1.5" opacity="0.45" />
        <ellipse cx="78" cy="30" rx="5" ry="4" fill="#4a2f1f" />
        <ellipse cx="97" cy="34" rx="4" ry="3.2" fill="#4a2f1f" />
        <ellipse cx="74" cy="50" rx="4.2" ry="3.4" fill="#4a2f1f" />
        <ellipse cx="92" cy="56" rx="5" ry="3.8" fill="#4a2f1f" />
        <ellipse cx="107" cy="48" rx="3.4" ry="2.8" fill="#4a2f1f" />
        <ellipse cx="84" cy="66" rx="3" ry="2.4" fill="#4a2f1f" />
        {/* soft highlight on the chips */}
        <ellipse cx="77" cy="29" rx="1.6" ry="1.1" fill="#8a5a3c" />
        <ellipse cx="91" cy="55" rx="1.6" ry="1.1" fill="#8a5a3c" />
      </g>
    </g>

    {/* crumbs */}
    <g className={css.crumbs} fill="#d9a463">
      <circle cx="122" cy="8" r="2.4" />
      <circle cx="132" cy="18" r="1.8" />
      <circle cx="128" cy="44" r="2" />
      <circle cx="12" cy="40" r="1.8" />
      <circle cx="18" cy="82" r="2.2" />
      <circle cx="70" cy="88" r="1.6" />
    </g>
  </svg>
);

export default CookieArt;
